<template lang="pug"></template>

<script>
import language from '../../../../build/language/index.js'
import PATHS from '../../../router/routesMap.js'

export default {
  name: 'LoginEmulado',

  data () {
    return {
      isLogin: false
    }
  },

  computed: {
    isLoggedIn () {
      return this.$store.getters.isLoggedIn
    }
  },

  methods: {
    login () {
      let lang = this.$route.query.idioma
      localStorage.removeItem('token')
      language.setLanguageEmulatedLogin(lang)
      this.$store.dispatch('loginEmulado', {token: this.$route.query.token}).then((response) => {
        this.$store.dispatch('setPerfilAcesso', { id: response.perfilAcesso.id, nome: response.perfilAcesso.nome })
        this.$store.dispatch('setClientEmulatedLogin', {client: response.cliente.id, clientName: response.cliente.nomeFantasia, singleClient: true}).then((response) => {
          this.$store.dispatch('getFuncionalities').then((response) => {
            this.isLoadingData = false
            this.funcionalitiesGroup = response.data.funcList
            this.$store.dispatch('saveAllowedFuncionalities', response.data.allowedFunc).then((response) => {
              location.href = PATHS.HOME
            })
          })
        })
      }).catch((error) => {
        this.$store.dispatch('logout').then(() => {
          this.$root.$refs.notification.error(error.message)
          this.$router.push(PATHS.LOGIN)
        })
      })
    }
  },

  created () {
    this.login()
  }
}
</script>



// WEBPACK FOOTER //
// LoginEmulado.vue?396fd70e